import { zeigeGlobalenHinweis, type HinweisArt } from "../calendar/globalerHinweis";

/**
 * T-29 — was nach „Bestehendem Vorgang zuordnen" aus der geöffneten Mail
 * (Lesebereich und Mailfenster) gesagt wird.
 *
 * Früher kam das per `window.alert`: blockierend und für unsere Nutzer
 * (Windows + Edge) ein Fremdkörper. Jetzt ein Hinweis in KMVS über den
 * globalen Kanal (`globalerHinweis`) — der hängt am WindowLayer und nicht am
 * Mailfenster, das `finishRead` direkt danach schließt.
 *
 * - Nur Erfolg (weitere Mails mitgenommen): `info`, blendet von selbst aus.
 * - Mit Problemen (Teilfehler, gekappte Überlänge): `fehler`, bleibt stehen,
 *   bis der Nutzer ihn wegklickt — der Fall darf nicht davonhuschen.
 *
 * Beides landet in EINEM Hinweis, denn der Kanal zeigt immer nur einen; ein
 * zweiter würde den ersten sofort ersetzen.
 */
export function zuordnenHinweis(
    mitgenommen: readonly string[],
    probleme: string | null,
): { text: string; art: HinweisArt } | null {
    const teile = [...new Set(mitgenommen.filter(Boolean))];
    if (probleme) teile.push(probleme);
    if (teile.length === 0) return null;
    return { text: teile.join(" "), art: probleme ? "fehler" : "info" };
}

/** Zeigt den Hinweis aus `zuordnenHinweis` an — ohne Inhalt passiert nichts. */
export function meldeZuordnenHinweis(mitgenommen: readonly string[], probleme: string | null): void {
    const hinweis = zuordnenHinweis(mitgenommen, probleme);
    if (hinweis) zeigeGlobalenHinweis(hinweis.text, { art: hinweis.art });
}
